import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import SvgNotAllowed from '@material-ui/icons/NotInterested';

const styles = (theme) => {
    return {
        button: {
            position: 'relative',
            float: 'left',
            margin: 8,
            width: 180,
            height: 150,
            borderColor: theme.palette.common.transparent,
            borderWidth: 1,
            borderStyle: 'solid',
            cursor: 'pointer',
            textAlign: 'center',
            '&:hover:not($disabled)': {
            },
            '&$disabled': {
                cursor: 'default',
            },
            '&$selected:not($disabled)': {
                borderColor: theme.palette.secondary.main,
            },
        },
        disabled: {},
        selected: {},
        disabledOverlay: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.73)',
        },
        disabledIcon: {
            ...theme.iconStyle.size[80],
            color: 'rgba(180, 180, 180, 0.23)',
            padding: 0,
            marginTop: 8,
            marginBottom: 4,
        },
        disabledText: {
            width: '100%',
            color: theme.palette.primary.displayText,
        },
    };
}

class SelectionButton extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selected: false,
        };
    }

    render = () => {
        const {classes} = this.props;

        const buttonClasses = classNames(classes.button,
            this.props.disabled ? classes.disabled : '',
            this.state.selected ? classes.selected : '');

        return (
            <Paper
                className={buttonClasses}
                onClick={this._handleClick}
            >
                {this.props.children}
                {this._renderDisabledOverlay()}
            </Paper>
        );
    }

    _renderDisabledOverlay = () => {
        if (!this.props.disabled) {
            return null;
        }

        const {classes} = this.props;

        return (
            <div className={classes.disabledOverlay}>
                <SvgNotAllowed className={classes.disabledIcon}/>
                <Typography className={classes.disabledText}>
                    Analysis not avaliable for current imagery
                </Typography>
            </div>
        );
    }

    _handleClick = (e) => {
        if (this.props.disabled) {
            return;
        }

        const selectedState = !this.state.selected;

        this.setState({selected: selectedState});

        if (this.props.onClick) {
            this.props.onClick(e, this.props.value, selectedState);
        }
    }
}

SelectionButton.propTypes = {
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    value: PropTypes.any.isRequired,
}

export default withStyles(styles)(SelectionButton);
